var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "reporting-section" },
    [
      _c("div", { staticClass: "section-header" }, [
        _c("i", { staticClass: "material-icons section-icon" }, [
          _vm._v("visibility"),
        ]),
        _c("h2", [
          _vm._v(_vm._s(_vm.$t("dash.reporting.section.impressions.title"))),
        ]),
      ]),
      _vm.network === "linkedin"
        ? [
            _c(
              "div",
              { staticClass: "metric-row" },
              [
                _c("MetricCard", {
                  attrs: {
                    value: _vm.stats.page.totalImpressions || 0,
                    "previous-value": _vm.prev("totalImpressions"),
                    label: _vm.$t("dash.reporting.impression"),
                    icon: "remove_red_eye",
                  },
                }),
                _vm.stats.page.totalUniqueImpressions != null
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.stats.page.totalUniqueImpressions || 0,
                        "previous-value": _vm.prev("totalUniqueImpressions"),
                        label: _vm.$t("dash.reporting.unique_impression"),
                        icon: "visibility_off",
                      },
                    })
                  : _vm._e(),
                _vm.stats.page.page_views != null
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.stats.page.page_views || 0,
                        "previous-value": _vm.prev("page_views"),
                        label: _vm.$t("dash.reporting.page_views"),
                        icon: "web",
                      },
                    })
                  : _vm._e(),
                _vm.stats.page.pageCustomButtonClickCounts != null
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.stats.page.pageCustomButtonClickCounts || 0,
                        "previous-value": _vm.prev(
                          "pageCustomButtonClickCounts"
                        ),
                        label: _vm.$t(
                          "dash.reporting.pageCustomButtonClickCounts"
                        ),
                        icon: "touch_app",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm.liImpressionsGraphData.length && _vm.liImpressionsLabels.length
              ? [
                  _c("div", { staticClass: "graph-title" }, [
                    _vm._v(_vm._s(_vm.$t("dash.reporting.impression"))),
                  ]),
                  _c(
                    "div",
                    { staticClass: "graph-wrap" },
                    [
                      _c("Graph", {
                        attrs: {
                          id: `impressions-li-${_vm.graphId}`,
                          data: _vm.liImpressionsGraphData,
                          labels: _vm.liImpressionsLabels,
                          height: "220px",
                          width: "100%",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm.liPageGraphData.length && _vm.liPageLabels.length
              ? [
                  _c("div", { staticClass: "graph-title" }, [
                    _vm._v(_vm._s(_vm.$t("dash.reporting.page_views"))),
                  ]),
                  _c(
                    "div",
                    { staticClass: "graph-wrap" },
                    [
                      _c("Graph", {
                        attrs: {
                          id: `pageviews-li-${_vm.graphId}`,
                          data: _vm.liPageGraphData,
                          labels: _vm.liPageLabels,
                          height: "220px",
                          width: "100%",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ]
        : [
            _c(
              "div",
              { staticClass: "metric-row" },
              [
                _vm.totalPageViews != null
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.totalPageViews,
                        "previous-value": _vm.prev("page_views_total"),
                        label: _vm.$t("dash.reporting.page_views"),
                        icon: "web",
                      },
                    })
                  : _vm._e(),
                _c("MetricCard", {
                  attrs: {
                    value: _vm.stats.page.totalImpressions || 0,
                    "previous-value": _vm.prev("totalImpressions"),
                    label: _vm.$t("dash.reporting.impression"),
                    icon: "remove_red_eye",
                  },
                }),
                _vm.totalReach != null
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.totalReach,
                        "previous-value": _vm.prev("totalReach"),
                        label: _vm.$t("dash.label.fb.impressions_reach"),
                        icon: "people",
                      },
                    })
                  : _vm._e(),
                _vm.totalOrganic != null
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.totalOrganic,
                        "previous-value": null,
                        label: _vm.$t("dash.label.fb.impressions_organic"),
                        icon: "eco",
                      },
                    })
                  : _vm._e(),
                _vm.totalPaid != null
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.totalPaid,
                        "previous-value": null,
                        label: _vm.$t("dash.label.fb.impressions_paid"),
                        icon: "monetization_on",
                      },
                    })
                  : _vm._e(),
                _vm.totalViral != null
                  ? _c("MetricCard", {
                      attrs: {
                        value: _vm.totalViral,
                        "previous-value": null,
                        label: _vm.$t("dash.label.fb.impressions_viral"),
                        icon: "share",
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
            _vm.mainGraphData.length && _vm.graphLabels.length
              ? [
                  _c("div", { staticClass: "graph-title" }, [
                    _vm._v(_vm._s(_vm.$t("dash.reporting.impression"))),
                  ]),
                  _c(
                    "div",
                    { staticClass: "graph-wrap" },
                    [
                      _c("Graph", {
                        attrs: {
                          id: `impressions-main-${_vm.graphId}`,
                          data: _vm.mainGraphData,
                          labels: _vm.graphLabels,
                          height: "220px",
                          width: "100%",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
            _vm.breakdownGraphData.length && _vm.breakdownLabels.length
              ? [
                  _c("div", { staticClass: "graph-title" }, [
                    _vm._v(
                      _vm._s(
                        _vm.$t("dash.reporting.section.impressions.subtitle")
                      )
                    ),
                  ]),
                  _c(
                    "div",
                    { staticClass: "graph-wrap" },
                    [
                      _c("Graph", {
                        attrs: {
                          id: `impressions-breakdown-${_vm.graphId}`,
                          data: _vm.breakdownGraphData,
                          labels: _vm.breakdownLabels,
                          height: "220px",
                          width: "100%",
                        },
                      }),
                    ],
                    1
                  ),
                ]
              : _vm._e(),
          ],
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }